import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import {
  RelatedLinks,
  RelatedLinksAnalytics
} from './models/related-links.interfaces';

@Component({
  selector: 'idp-related-links',
  templateUrl: './related-links.component.html',
  styleUrls: ['./related-links.component.scss']
})
export class RelatedLinksComponent {
  @Input() content: RelatedLinks = {} as RelatedLinks;
  @Output() analyticsEvent = new EventEmitter<RelatedLinksAnalytics>();

  onLinkClick(action: Link): void {
    this.analyticsEvent.emit({
      action,
      eventType: 'link_click'
    });
  }

  redirect(event: string) {
    window.open(event, '_blank');
  }
}
